var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcBgDots = function SvgIcBgDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 115,
    viewBox: "0 0 132 115",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 10.425C8.11594 10.425 10.4568 8.09121 10.4568 5.21245C10.4568 2.33368 8.11594 0 5.22838 0C2.34082 0 0 2.33368 0 5.21245C0 8.09121 2.34082 10.425 5.22838 10.425Z",
    fill: "url(#paint1_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 0,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 10.425C38.3972 10.425 40.738 8.09121 40.738 5.21245C40.738 2.33368 38.3972 0 35.5096 0C32.6221 0 30.2812 2.33368 30.2812 5.21245C30.2812 8.09121 32.6221 10.425 35.5096 10.425Z",
    fill: "url(#paint2_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 10.425C38.3972 10.425 40.738 8.09121 40.738 5.21245C40.738 2.33368 38.3972 0 35.5096 0C32.6221 0 30.2812 2.33368 30.2812 5.21245C30.2812 8.09121 32.6221 10.425 35.5096 10.425Z",
    fill: "url(#paint3_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 0,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 10.425C68.6784 10.425 71.0193 8.09121 71.0193 5.21245C71.0193 2.33368 68.6784 0 65.7909 0C62.9033 0 60.5625 2.33368 60.5625 5.21245C60.5625 8.09121 62.9033 10.425 65.7909 10.425Z",
    fill: "url(#paint4_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 10.425C68.6784 10.425 71.0193 8.09121 71.0193 5.21245C71.0193 2.33368 68.6784 0 65.7909 0C62.9033 0 60.5625 2.33368 60.5625 5.21245C60.5625 8.09121 62.9033 10.425 65.7909 10.425Z",
    fill: "url(#paint5_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 0,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 10.425C98.9587 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9587 0 96.0712 0C93.1836 0 90.8428 2.33368 90.8428 5.21245C90.8428 8.09121 93.1836 10.425 96.0712 10.425Z",
    fill: "url(#paint6_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 10.425C98.9587 10.425 101.3 8.09121 101.3 5.21245C101.3 2.33368 98.9587 0 96.0712 0C93.1836 0 90.8428 2.33368 90.8428 5.21245C90.8428 8.09121 93.1836 10.425 96.0712 10.425Z",
    fill: "url(#paint7_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 0,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.352 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.352 10.425Z",
    fill: "url(#paint8_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 10.425C129.24 10.425 131.581 8.09121 131.581 5.21245C131.581 2.33368 129.24 0 126.352 0C123.465 0 121.124 2.33368 121.124 5.21245C121.124 8.09121 123.465 10.425 126.352 10.425Z",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 26,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3833C10.4568 28.5046 8.11594 26.1709 5.22838 26.1709C2.34082 26.1709 0 28.5046 0 31.3833C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint10_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 36.5958C8.11594 36.5958 10.4568 34.2621 10.4568 31.3833C10.4568 28.5046 8.11594 26.1709 5.22838 26.1709C2.34082 26.1709 0 28.5046 0 31.3833C0 34.2621 2.34082 36.5958 5.22838 36.5958Z",
    fill: "url(#paint11_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 26,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 36.5958C38.3972 36.5958 40.738 34.2621 40.738 31.3833C40.738 28.5046 38.3972 26.1709 35.5096 26.1709C32.6221 26.1709 30.2812 28.5046 30.2812 31.3833C30.2812 34.2621 32.6221 36.5958 35.5096 36.5958Z",
    fill: "url(#paint12_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 36.5958C38.3972 36.5958 40.738 34.2621 40.738 31.3833C40.738 28.5046 38.3972 26.1709 35.5096 26.1709C32.6221 26.1709 30.2812 28.5046 30.2812 31.3833C30.2812 34.2621 32.6221 36.5958 35.5096 36.5958Z",
    fill: "url(#paint13_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 26,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 36.5958C68.6784 36.5958 71.0193 34.2621 71.0193 31.3833C71.0193 28.5046 68.6784 26.1709 65.7909 26.1709C62.9033 26.1709 60.5625 28.5046 60.5625 31.3833C60.5625 34.2621 62.9033 36.5958 65.7909 36.5958Z",
    fill: "url(#paint14_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 36.5958C68.6784 36.5958 71.0193 34.2621 71.0193 31.3833C71.0193 28.5046 68.6784 26.1709 65.7909 26.1709C62.9033 26.1709 60.5625 28.5046 60.5625 31.3833C60.5625 34.2621 62.9033 36.5958 65.7909 36.5958Z",
    fill: "url(#paint15_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 26,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 36.5958C98.9587 36.5958 101.3 34.2621 101.3 31.3833C101.3 28.5046 98.9587 26.1709 96.0712 26.1709C93.1836 26.1709 90.8428 28.5046 90.8428 31.3833C90.8428 34.2621 93.1836 36.5958 96.0712 36.5958Z",
    fill: "url(#paint16_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 36.5958C98.9587 36.5958 101.3 34.2621 101.3 31.3833C101.3 28.5046 98.9587 26.1709 96.0712 26.1709C93.1836 26.1709 90.8428 28.5046 90.8428 31.3833C90.8428 34.2621 93.1836 36.5958 96.0712 36.5958Z",
    fill: "url(#paint17_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 26,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3833C131.581 28.5046 129.24 26.1709 126.352 26.1709C123.465 26.1709 121.124 28.5046 121.124 31.3833C121.124 34.2621 123.465 36.5958 126.352 36.5958Z",
    fill: "url(#paint18_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 36.5958C129.24 36.5958 131.581 34.2621 131.581 31.3833C131.581 28.5046 129.24 26.1709 126.352 26.1709C123.465 26.1709 121.124 28.5046 121.124 31.3833C121.124 34.2621 123.465 36.5958 126.352 36.5958Z",
    fill: "url(#paint19_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 52,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 62.7126C8.11594 62.7126 10.4568 60.3789 10.4568 57.5001C10.4568 54.6213 8.11594 52.2876 5.22838 52.2876C2.34082 52.2876 0 54.6213 0 57.5001C0 60.3789 2.34082 62.7126 5.22838 62.7126Z",
    fill: "url(#paint20_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 62.7126C8.11594 62.7126 10.4568 60.3789 10.4568 57.5001C10.4568 54.6213 8.11594 52.2876 5.22838 52.2876C2.34082 52.2876 0 54.6213 0 57.5001C0 60.3789 2.34082 62.7126 5.22838 62.7126Z",
    fill: "url(#paint21_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 52,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 62.7126C38.3972 62.7126 40.738 60.3789 40.738 57.5001C40.738 54.6213 38.3972 52.2876 35.5096 52.2876C32.6221 52.2876 30.2812 54.6213 30.2812 57.5001C30.2812 60.3789 32.6221 62.7126 35.5096 62.7126Z",
    fill: "url(#paint22_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 62.7126C38.3972 62.7126 40.738 60.3789 40.738 57.5001C40.738 54.6213 38.3972 52.2876 35.5096 52.2876C32.6221 52.2876 30.2812 54.6213 30.2812 57.5001C30.2812 60.3789 32.6221 62.7126 35.5096 62.7126Z",
    fill: "url(#paint23_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 52,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 62.7126C68.6784 62.7126 71.0193 60.3789 71.0193 57.5001C71.0193 54.6213 68.6784 52.2876 65.7909 52.2876C62.9033 52.2876 60.5625 54.6213 60.5625 57.5001C60.5625 60.3789 62.9033 62.7126 65.7909 62.7126Z",
    fill: "url(#paint24_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 62.7126C68.6784 62.7126 71.0193 60.3789 71.0193 57.5001C71.0193 54.6213 68.6784 52.2876 65.7909 52.2876C62.9033 52.2876 60.5625 54.6213 60.5625 57.5001C60.5625 60.3789 62.9033 62.7126 65.7909 62.7126Z",
    fill: "url(#paint25_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 52,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 62.7126C98.9587 62.7126 101.3 60.3789 101.3 57.5001C101.3 54.6213 98.9587 52.2876 96.0712 52.2876C93.1836 52.2876 90.8428 54.6213 90.8428 57.5001C90.8428 60.3789 93.1836 62.7126 96.0712 62.7126Z",
    fill: "url(#paint26_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 62.7126C98.9587 62.7126 101.3 60.3789 101.3 57.5001C101.3 54.6213 98.9587 52.2876 96.0712 52.2876C93.1836 52.2876 90.8428 54.6213 90.8428 57.5001C90.8428 60.3789 93.1836 62.7126 96.0712 62.7126Z",
    fill: "url(#paint27_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 52,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 62.7126C129.24 62.7126 131.581 60.3789 131.581 57.5001C131.581 54.6213 129.24 52.2876 126.352 52.2876C123.465 52.2876 121.124 54.6213 121.124 57.5001C121.124 60.3789 123.465 62.7126 126.352 62.7126Z",
    fill: "url(#paint28_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 62.7126C129.24 62.7126 131.581 60.3789 131.581 57.5001C131.581 54.6213 129.24 52.2876 126.352 52.2876C123.465 52.2876 121.124 54.6213 121.124 57.5001C121.124 60.3789 123.465 62.7126 126.352 62.7126Z",
    fill: "url(#paint29_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 78,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 88.8835C8.11594 88.8835 10.4568 86.5497 10.4568 83.6709C10.4568 80.7922 8.11594 78.4585 5.22838 78.4585C2.34082 78.4585 0 80.7922 0 83.6709C0 86.5497 2.34082 88.8835 5.22838 88.8835Z",
    fill: "url(#paint30_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 88.8835C8.11594 88.8835 10.4568 86.5497 10.4568 83.6709C10.4568 80.7922 8.11594 78.4585 5.22838 78.4585C2.34082 78.4585 0 80.7922 0 83.6709C0 86.5497 2.34082 88.8835 5.22838 88.8835Z",
    fill: "url(#paint31_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 78,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 88.8835C38.3972 88.8835 40.738 86.5497 40.738 83.6709C40.738 80.7922 38.3972 78.4585 35.5096 78.4585C32.6221 78.4585 30.2812 80.7922 30.2812 83.6709C30.2812 86.5497 32.6221 88.8835 35.5096 88.8835Z",
    fill: "url(#paint32_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 88.8835C38.3972 88.8835 40.738 86.5497 40.738 83.6709C40.738 80.7922 38.3972 78.4585 35.5096 78.4585C32.6221 78.4585 30.2812 80.7922 30.2812 83.6709C30.2812 86.5497 32.6221 88.8835 35.5096 88.8835Z",
    fill: "url(#paint33_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 78,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 88.8835C68.6784 88.8835 71.0193 86.5497 71.0193 83.6709C71.0193 80.7922 68.6784 78.4585 65.7909 78.4585C62.9033 78.4585 60.5625 80.7922 60.5625 83.6709C60.5625 86.5497 62.9033 88.8835 65.7909 88.8835Z",
    fill: "url(#paint34_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 88.8835C68.6784 88.8835 71.0193 86.5497 71.0193 83.6709C71.0193 80.7922 68.6784 78.4585 65.7909 78.4585C62.9033 78.4585 60.5625 80.7922 60.5625 83.6709C60.5625 86.5497 62.9033 88.8835 65.7909 88.8835Z",
    fill: "url(#paint35_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 78,
    width: 12,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 88.8835C98.9587 88.8835 101.3 86.5497 101.3 83.6709C101.3 80.7922 98.9587 78.4585 96.0712 78.4585C93.1836 78.4585 90.8428 80.7922 90.8428 83.6709C90.8428 86.5497 93.1836 88.8835 96.0712 88.8835Z",
    fill: "url(#paint36_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 88.8835C98.9587 88.8835 101.3 86.5497 101.3 83.6709C101.3 80.7922 98.9587 78.4585 96.0712 78.4585C93.1836 78.4585 90.8428 80.7922 90.8428 83.6709C90.8428 86.5497 93.1836 88.8835 96.0712 88.8835Z",
    fill: "url(#paint37_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 78,
    width: 11,
    height: 11
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 88.8835C129.24 88.8835 131.581 86.5497 131.581 83.6709C131.581 80.7922 129.24 78.4585 126.352 78.4585C123.465 78.4585 121.124 80.7922 121.124 83.6709C121.124 86.5497 123.465 88.8835 126.352 88.8835Z",
    fill: "url(#paint38_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 88.8835C129.24 88.8835 131.581 86.5497 131.581 83.6709C131.581 80.7922 129.24 78.4585 126.352 78.4585C123.465 78.4585 121.124 80.7922 121.124 83.6709C121.124 86.5497 123.465 88.8835 126.352 88.8835Z",
    fill: "url(#paint39_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 104,
    width: 11,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.788C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.788C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint40_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22838 115C8.11594 115 10.4568 112.666 10.4568 109.788C10.4568 106.909 8.11594 104.575 5.22838 104.575C2.34082 104.575 0 106.909 0 109.788C0 112.666 2.34082 115 5.22838 115Z",
    fill: "url(#paint41_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 104,
    width: 11,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 115C38.3972 115 40.738 112.666 40.738 109.788C40.738 106.909 38.3972 104.575 35.5096 104.575C32.6221 104.575 30.2812 106.909 30.2812 109.788C30.2812 112.666 32.6221 115 35.5096 115Z",
    fill: "url(#paint42_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.5096 115C38.3972 115 40.738 112.666 40.738 109.788C40.738 106.909 38.3972 104.575 35.5096 104.575C32.6221 104.575 30.2812 106.909 30.2812 109.788C30.2812 112.666 32.6221 115 35.5096 115Z",
    fill: "url(#paint43_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 104,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 115C68.6784 115 71.0193 112.666 71.0193 109.788C71.0193 106.909 68.6784 104.575 65.7909 104.575C62.9033 104.575 60.5625 106.909 60.5625 109.788C60.5625 112.666 62.9033 115 65.7909 115Z",
    fill: "url(#paint44_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.7909 115C68.6784 115 71.0193 112.666 71.0193 109.788C71.0193 106.909 68.6784 104.575 65.7909 104.575C62.9033 104.575 60.5625 106.909 60.5625 109.788C60.5625 112.666 62.9033 115 65.7909 115Z",
    fill: "url(#paint45_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 104,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 115C98.9587 115 101.3 112.666 101.3 109.788C101.3 106.909 98.9587 104.575 96.0712 104.575C93.1836 104.575 90.8428 106.909 90.8428 109.788C90.8428 112.666 93.1836 115 96.0712 115Z",
    fill: "url(#paint46_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.0712 115C98.9587 115 101.3 112.666 101.3 109.788C101.3 106.909 98.9587 104.575 96.0712 104.575C93.1836 104.575 90.8428 106.909 90.8428 109.788C90.8428 112.666 93.1836 115 96.0712 115Z",
    fill: "url(#paint47_linear)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 104,
    width: 11,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 115C129.24 115 131.581 112.666 131.581 109.788C131.581 106.909 129.24 104.575 126.352 104.575C123.465 104.575 121.124 106.909 121.124 109.788C121.124 112.666 123.465 115 126.352 115Z",
    fill: "url(#paint48_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.352 115C129.24 115 131.581 112.666 131.581 109.788C131.581 106.909 129.24 104.575 126.352 104.575C123.465 104.575 121.124 106.909 121.124 109.788C121.124 112.666 123.465 115 126.352 115Z",
    fill: "url(#paint49_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 54.996,
    y1: 131.134,
    x2: -16.4057,
    y2: -50.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 81.2007,
    y1: 120.843,
    x2: 9.79907,
    y2: -60.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 81.2007,
    y1: 120.843,
    x2: 9.79907,
    y2: -60.9613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 107.405,
    y1: 110.551,
    x2: 36.0037,
    y2: -71.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 107.405,
    y1: 110.551,
    x2: 36.0037,
    y2: -71.2526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 133.609,
    y1: 100.259,
    x2: 62.2071,
    y2: -81.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 133.609,
    y1: 100.259,
    x2: 62.2071,
    y2: -81.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 159.813,
    y1: 89.9679,
    x2: 88.4116,
    y2: -91.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 159.813,
    y1: 89.9679,
    x2: 88.4116,
    y2: -91.8359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 46.0538,
    y1: 134.645,
    x2: -25.3466,
    y2: -47.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 46.0538,
    y1: 134.645,
    x2: -25.3466,
    y2: -47.1572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 72.2583,
    y1: 124.354,
    x2: 0.857901,
    y2: -57.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 72.2583,
    y1: 124.354,
    x2: 0.857901,
    y2: -57.4491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 98.4628,
    y1: 114.062,
    x2: 27.0624,
    y2: -67.7404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 98.4628,
    y1: 114.062,
    x2: 27.0624,
    y2: -67.7404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 124.666,
    y1: 103.771,
    x2: 53.2659,
    y2: -78.0318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 124.666,
    y1: 103.771,
    x2: 53.2659,
    y2: -78.0318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 150.871,
    y1: 93.4793,
    x2: 79.4705,
    y2: -88.3232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 150.871,
    y1: 93.4793,
    x2: 79.4705,
    y2: -88.3232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 37.1113,
    y1: 138.158,
    x2: -34.2903,
    y2: -43.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 37.1113,
    y1: 138.158,
    x2: -34.2903,
    y2: -43.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 63.3159,
    y1: 127.867,
    x2: -8.08572,
    y2: -53.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 63.3159,
    y1: 127.867,
    x2: -8.08572,
    y2: -53.9373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 89.5204,
    y1: 117.575,
    x2: 18.1189,
    y2: -64.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 89.5204,
    y1: 117.575,
    x2: 18.1189,
    y2: -64.2287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear",
    x1: 115.724,
    y1: 107.283,
    x2: 44.3223,
    y2: -74.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear",
    x1: 115.724,
    y1: 107.283,
    x2: 44.3223,
    y2: -74.5204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear",
    x1: 141.928,
    y1: 96.992,
    x2: 70.5268,
    y2: -84.8119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear",
    x1: 141.928,
    y1: 96.992,
    x2: 70.5268,
    y2: -84.8119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear",
    x1: 28.169,
    y1: 141.67,
    x2: -43.2327,
    y2: -40.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear",
    x1: 28.169,
    y1: 141.67,
    x2: -43.2327,
    y2: -40.1338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear",
    x1: 54.3736,
    y1: 131.379,
    x2: -17.0281,
    y2: -50.4253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear",
    x1: 54.3736,
    y1: 131.379,
    x2: -17.0281,
    y2: -50.4253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear",
    x1: 80.578,
    y1: 121.087,
    x2: 9.17646,
    y2: -60.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear",
    x1: 80.578,
    y1: 121.087,
    x2: 9.17646,
    y2: -60.7167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear",
    x1: 106.782,
    y1: 110.796,
    x2: 35.3799,
    y2: -71.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear",
    x1: 106.782,
    y1: 110.796,
    x2: 35.3799,
    y2: -71.0083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear",
    x1: 132.986,
    y1: 100.504,
    x2: 61.5845,
    y2: -81.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear",
    x1: 132.986,
    y1: 100.504,
    x2: 61.5845,
    y2: -81.2999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear",
    x1: 19.2266,
    y1: 145.182,
    x2: -52.1751,
    y2: -36.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear",
    x1: 19.2266,
    y1: 145.182,
    x2: -52.1751,
    y2: -36.6217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear",
    x1: 45.4312,
    y1: 134.891,
    x2: -25.9705,
    y2: -46.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear",
    x1: 45.4312,
    y1: 134.891,
    x2: -25.9705,
    y2: -46.9132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear",
    x1: 71.6357,
    y1: 124.599,
    x2: 0.234115,
    y2: -57.2045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear",
    x1: 71.6357,
    y1: 124.599,
    x2: 0.234115,
    y2: -57.2045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear",
    x1: 97.8392,
    y1: 114.308,
    x2: 26.4376,
    y2: -67.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear",
    x1: 97.8392,
    y1: 114.308,
    x2: 26.4376,
    y2: -67.4962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear",
    x1: 124.044,
    y1: 104.016,
    x2: 52.6421,
    y2: -77.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear",
    x1: 124.044,
    y1: 104.016,
    x2: 52.6421,
    y2: -77.7877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#97C3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93C1F9"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBgDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_bg_dots.16ddd7a8.svg";
export { ForwardRef as ReactComponent };